import React, { useState, useEffect } from 'react';
import { listTechnicalBids } from '../services/api';
import { formatDate } from '../utils/formatDate';
import TechnicalBidDetail from './TechnicalBidDetail';
import './TenderList.css';

const STATUS_CLASS = {
  assigned: 'status-participating',
  in_progress: 'status-participating',
  submitted: 'status-submitted',
  approved: 'status-won',
  rejected: 'status-lost',
};

function MyTechnicalBidTasks({ user, onGoToParticipating }) {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [statusFilter, setStatusFilter] = useState('');
  const [viewingId, setViewingId] = useState(null);

  const fetchTasks = async () => {
    try {
      setLoading(true);
      const res = await listTechnicalBids({ assigned_to_me: 'true' });
      if (res.success) setTasks(res.technical_bids || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTasks();
  }, []);

  const filtered = statusFilter
    ? tasks.filter((t) => t.status === statusFilter)
    : tasks;

  return (
    <div className="tender-list-container">
      <div className="tender-list-header">
        <div className="header-title">
          <h2>My Technical Bid Tasks</h2>
          <p>Technical bid assignments assigned to you</p>
        </div>
      </div>

      {error && (
        <div className="error-message">
          {error}
          <button onClick={() => setError(null)}>×</button>
        </div>
      )}

      <div className="filters-section">
        <select
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
          style={{ padding: '8px 12px', borderRadius: '8px', border: '1px solid #d1d5db' }}
        >
          <option value="">All Statuses</option>
          <option value="assigned">Assigned</option>
          <option value="in_progress">In Progress</option>
          <option value="submitted">Submitted</option>
          <option value="approved">Approved</option>
          <option value="rejected">Rejected</option>
        </select>
      </div>

      {loading ? (
        <div className="tenders-table-wrapper">
          <table className="tenders-table table-skeleton">
            <thead>
              <tr>
                <th>Tender Ref</th>
                <th>Title</th>
                <th>Assigned By</th>
                <th>Due Date</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {[1, 2, 3, 4, 5].map((i) => (
                <tr key={i}>
                  <td><span className="skeleton-box" style={{ width: 100 }} /></td>
                  <td><span className="skeleton-box" style={{ width: '50%' }} /></td>
                  <td><span className="skeleton-box" style={{ width: 100 }} /></td>
                  <td><span className="skeleton-box" style={{ width: 88 }} /></td>
                  <td><span className="skeleton-box" style={{ width: 80 }} /></td>
                  <td><span className="skeleton-box" style={{ width: 50 }} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : filtered.length === 0 ? (
        <div className="empty-state">
          <h3>No technical bid tasks</h3>
          <p>
            {statusFilter
              ? `No tasks with status "${statusFilter}"`
              : 'Tasks assigned to you will appear here'}
          </p>
          {!statusFilter && onGoToParticipating && (
            <button type="button" onClick={onGoToParticipating}>View participating tenders</button>
          )}
        </div>
      ) : (
        <div className="tenders-table-wrapper">
          <table className="tenders-table">
            <thead>
              <tr>
                <th>Tender Ref</th>
                <th>Title</th>
                <th>Assigned By</th>
                <th>Due Date</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((t) => (
                <tr key={t.id}>
                  <td>
                    <button
                      type="button"
                      className="ref-code ref-code-link"
                      onClick={() => setViewingId(t.id)}
                    >
                      {t.tender_ref || t.tender_id}
                    </button>
                  </td>
                  <td>
                    <span className="tender-title-inline">{t.tender_title || '–'}</span>
                  </td>
                  <td>{t.assigned_by_name || '–'}</td>
                  <td>{formatDate(t.due_date)}</td>
                  <td>
                    <span className={`status-badge ${STATUS_CLASS[t.status] || 'status-default'}`}>
                      {t.status_display || t.status}
                    </span>
                  </td>
                  <td>
                    <button
                      type="button"
                      className="link-btn"
                      style={{ padding: 0, fontSize: '13px' }}
                      onClick={() => setViewingId(t.id)}
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {!loading && filtered.length > 0 && (
        <div className="list-footer">
          <span>Total: {filtered.length} task(s)</span>
        </div>
      )}

      {viewingId && (
        <TechnicalBidDetail
          technicalBidId={viewingId}
          user={user}
          canManage={false}
          onClose={() => {
            setViewingId(null);
            fetchTasks();
          }}
        />
      )}
    </div>
  );
}

export default MyTechnicalBidTasks;
